export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.woff2?31015e861aeb30ff8355fab3e876a6bd";